export const envConfig = {
  isProduction: process.env.NODE_ENV === 'production',
  appVersion: process.env.version,
  firebase: {
    apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY,
    authDomain: process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID,
    appId: process.env.NEXT_PUBLIC_FIREBASE_APP_ID,
    privateKeyId: process.env.FIREBASE_PRIVATE_KEY_ID,
    privateKey: process.env.FIREBASE_PRIVATE_KEY,
    clientEmail: process.env.FIREBASE_PRIVATE_CLIENT_EMAIL,
    clientId: process.env.FIREBASE_PRIVATE_CLIENT_ID,
  },
  mazeId: process.env.NEXT_PUBLIC_MAZE_ID,
  sentry: {
    dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
    environment: process.env.NEXT_PUBLIC_SENTRY_ENVIRONMENT ?? 'staging',
  },
  userGuiding: {
    containerId: process.env.NEXT_PUBLIC_USER_GUIDING_CONTAINER_ID,
  },
  salesforce: {
    chat: {
      chatName: process.env.NEXT_PUBLIC_SALESFORCE_CHAT_NAME,
      queueId: process.env.NEXT_PUBLIC_SALESFORCE_QUEUE_ID,
      queueName: process.env.NEXT_PUBLIC_SALESFORCE_QUEUE_NAME,
    },
  },
  stream: {
    apiKey: process.env.NEXT_PUBLIC_STREAM_API_KEY ?? '',
    secretKey: process.env.STREAM_SECRET_KEY ?? '',
  },
};
